import { render, staticRenderFns } from "./InstrumentBar.vue?vue&type=template&id=1dcbd6d0"
import script from "./InstrumentBar.vue?vue&type=script&lang=js"
export * from "./InstrumentBar.vue?vue&type=script&lang=js"
import style0 from "./InstrumentBar.vue?vue&type=style&index=0&id=1dcbd6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports